import { render, staticRenderFns } from "./DateWithMenu.vue?vue&type=template&id=1a192852"
import script from "./DateWithMenu.vue?vue&type=script&lang=js"
export * from "./DateWithMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports